// @ts-nocheck
import pause from './assets/pause.svg';
import play from './assets/play.svg';
import hlsPlus from './assets/hls+.svg';
import hls from './assets/hls.svg';
import skip from './assets/skip_forward.svg';
import vol0 from './assets/volume0.svg';
import vol1 from './assets/volume1.svg';
import vol2 from './assets/volume2.svg';
import vol3 from './assets/volume3.svg';
import defaultAlbumArt from './assets/default_album_artwork_640.png';

export const Icons = {
    pause,
    play,
    hlsPlus,
    hls,
    skip,
    vol0,
    vol1,
    vol2,
    vol3,
};

export const Images = {
    defaultAlbumArt,
};